export default "__VITE_ASSET__CH41ORr7__"